import { ApiDealerXClient } from '@dealer-group/dealer-api-clients';

export function getFileInfo(fileUuid) {
    return ApiDealerXClient.get(`media/${fileUuid}/info`);
}

export function getThumbnailUrl(fileUuid) {
    return `${ApiDealerXClient.options.baseURL}/open/media/images/${fileUuid}?width=200&height=200`;
}

export function getImageUrl(fileUuid) {
    return `${ApiDealerXClient.options.baseURL}/open/media/${fileUuid}`;
}

export function downloadFile(fileUuid) {
    return ApiDealerXClient.get(`media/${fileUuid}`, '', {}, {responseType: 'blob'});
}
